import { User } from '../../models/User';
import { useState } from 'react';
import { UserTable } from './UserTable';

interface ContactsSectionProps {
  users: User[];
  isAdmin: boolean;
  isContactsLoaded: boolean;
}
export const ContactsSection = (props: ContactsSectionProps) => {
  return (
    <div id="contacts" className="relative h-fit dark:bg-slate-900 bg-slate-50">
      <div className="container mx-auto px-6 flex relative py-8 sm:py-16">
        <div className="w-full flex flex-col relative">
          <h1 className="text-2xl sm:text-4xl font-extrabold tracking-tight mb-6 dark:text-white text-slate-900">
            Family Contacts
          </h1>
          <ContactsSearch users={props.users} isAdmin={props.isAdmin} isContactsLoaded={props.isContactsLoaded} />
        </div>
      </div>
    </div>
  );
};

const ContactsSearch = (props: ContactsSectionProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      <div className="mb-6 relative">
        <input
          type="text"
          placeholder="Search contacts..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-4 pl-12 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all shadow-sm"
        />
        <svg className="w-6 h-6 absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <UserTable users={props.users} isAdmin={props.isAdmin} isContactsLoaded={props.isContactsLoaded} searchQuery={searchQuery} />
    </>
  );
};
